// removed by extract-text-webpack-plugin
module.exports = {"base":"Body_base--irita","content":"Body_content--klbb0","content__scrollable":"Body_content__scrollable--1bnwQ","contentScrollable":"Body_content__scrollable--1bnwQ","message":"Body_message--1hrw8","announcementInfo":"Body_announcementInfo--24xQ1","announcementInfo__dots":"Body_announcementInfo__dots--2mxRH","announcementInfoDots":"Body_announcementInfo__dots--2mxRH","announcementTime":"Body_announcementTime--6k49N"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/components/Body/Body.scss
// module id = 2325
// module chunks = 11